<!-- <app-header-three></app-header-three> -->
<!-- [sticky]="true" -->

<div class="main-container">
    <div class="headers" #header>
        <app-mfg-header [genieName]="genieName"></app-mfg-header>
    </div>
    <!-- Commented on 25theDec(app-scanner-animate) -->
    <!-- <app-scanner-animate *ngIf="showScannerAnimate"></app-scanner-animate> -->
    <!-- <app-cart-header [genieName]="genieName"></app-cart-header> -->
    <div class="route-content" [ngStyle]="{ 'padding-top.px': headerHeight }">
        <router-outlet></router-outlet>
    </div>

    <div class="footer">
        <app-mfg-footer></app-mfg-footer>
    </div>
</div>